import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { map } from 'lodash';

import FiltersSelectContent from '../FiltersSelectContent';

const messages = defineMessages({
  delivered: {
    id: 'core.FiltersDialog.components.FiltersMessageStatus.delivered',
    defaultMessage: 'Delivered',
  },
  sent: {
    id: 'core.FiltersDialog.components.FiltersMessageStatus.sent',
    defaultMessage: 'Sent',
  },
  sentHelperText: {
    id: 'core.FiltersDialog.components.FiltersMessageStatus.sentHelperText',
    defaultMessage: 'The message was sent, but we haven’t received updated delivery information.',
  },
  undelivered: {
    id: 'core.FiltersDialog.components.FiltersMessageStatus.undelivered',
    defaultMessage: 'Undelivered',
  },
});

export function useFiltersMessageStatusItems() {
  const { formatMessage } = useIntl();

  return map(['delivered', 'sent', 'undelivered'], (id: keyof typeof messages) => ({
    _id: id,
    label: formatMessage(messages[id]),
    helperText: id === 'sent' && formatMessage(messages.sentHelperText),
  }));
}

const FiltersMessageStatus: React.FC = () => {
  const items = useFiltersMessageStatusItems();

  return <FiltersSelectContent type="messageStatus" items={items} />;
};
export default FiltersMessageStatus;
